import ChangeEmailPage from '@/pages/accounts/ChangeEmail';
import ChangePasswordPage from '@/pages/accounts/ChangePassword';
import { adminRoutes } from '@/routers/routes';
import { AuthenticationStoreContext } from '@/stores/authentication.store';
import { GroupOutlined, LockFilled, LogoutOutlined, MailOutlined } from '@ant-design/icons';
import { AccountCircle } from '@material-ui/icons';
import { Layout, Menu } from 'antd';
import React from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import './index.less';

const { Content, Sider } = Layout;

export default function AdminLayout() {
  const menuItems = adminRoutes.filter((route) => route.isMenu);

  const [
    isChangePasswordModalVisible,
    setIsChangePasswordModalVisible,
  ] = React.useState(false);

  const [
    isChangeEmailModalVisible,
    setIsChangeEmailModalVisible,
  ] = React.useState(false);

  const [
    collapseStatusSider,
    changeCollapseStatusSider,
  ] = React.useState<boolean>(false);

  const authStore = React.useContext(AuthenticationStoreContext);

  const logout = () => {
    authStore.logout(history);
  };

  const setChangePasswordModal = (state: boolean) => {
    setIsChangePasswordModalVisible(state);
  };

  const setChangeEmailModal = (state: boolean) => {
    setIsChangeEmailModalVisible(state);
  };

  const history = useHistory();

  return (
    <>
      <Layout style={{ minHeight: '100vh' }}>
        <Sider
          theme="dark"
          style={{
            overflow: 'auto',
            height: '100vh',
            position: 'fixed',
            left: 0,
          }}
          collapsible
          collapsed={collapseStatusSider}
          onCollapse={changeCollapseStatusSider}
        >
          <div className="logo">
            <img
              src={`${process.env.REACT_APP_BACKEND_URL}/images/logoPDF.png`}
              alt=""
            />
          </div>
          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={[location.pathname]}
            forceSubMenuRender
          >
            <Menu.Item
              key="districts"
              icon={<GroupOutlined />}
              onClick={() => window.open('https://web.high5wizard.com/districts')}
            >
              Org. District Requests
            </Menu.Item>
            {menuItems.map((item) => (
              <Menu.Item
                key={item.path}
                icon={item.icon}
                onClick={() => history.push(item.path)}
              >
                {item.title}
              </Menu.Item>
            ))}

            <Menu.SubMenu
              key="subMenuUser"
              icon={
                <div
                  style={{ display: 'inline-flex', verticalAlign: 'middle' }}
                >
                  <AccountCircle style={{ fontSize: '17' }} />
                </div>
              }
              title="Profile"
              className="submenu-user"
            >
              <Menu.Item
                onClick={() => setChangePasswordModal(true)}
                icon={<LockFilled />}
              >
                Change Password
              </Menu.Item>

              <Menu.Item
                onClick={() => setChangeEmailModal(true)}
                icon={<MailOutlined />}
              >
                Change Email
              </Menu.Item>

              <Menu.Item
                onClick={() => {
                  logout();
                }}
                icon={<LogoutOutlined />}
              >
                Logout
              </Menu.Item>
            </Menu.SubMenu>
          </Menu>
        </Sider>
        <Layout
          className="site-layout"
          style={{ marginLeft: collapseStatusSider ? 80 : 200 }}
        >
          <Content className="main-content">
            {isChangePasswordModalVisible && (
              <ChangePasswordPage
                setChangePasswordModal={setChangePasswordModal}
              />
            )}
            {isChangeEmailModalVisible && (
              <ChangeEmailPage setChangeEmailModal={setChangeEmailModal} />
            )}

            <Switch>
              {adminRoutes
                .filter((item: any) => !item.isLayout)
                .map((item: any) => (
                  <Route
                    key={item.path}
                    path={item.path}
                    component={item.component}
                    exact={item.exact}
                  />
                ))}
              <Redirect to="/users" />
            </Switch>
          </Content>
        </Layout>
      </Layout>
    </>
  );
}
